export const mixpanelIdentityPath = {};

export const MIXPANEL_EVENTS = {
  ACCOUNT_SETTING: 'account_settings_tab_clicked',
  ACCREDITATION: 'accreditation_tab_clicked',
  ANNOUNCEMENT: 'announcement_tab_clicked',
  PROFILE_MANAGEMENT: 'profile_management_tab_clicked',
  VIEW_AUTOMATION_RULES: 'view_automation_tab_clicked',
  AUTOMATION_SUITE: 'automation_suite_section_clicked',
  MANAGE_TAGS: 'manage_tags_clicked',
  MANAGE_CERTIFICATES: 'manage_certificates_clicked',
  HELP_SITE: 'help_site_visit_tab_clicked',
  GET_SUPPORT: 'help_report_issue_tab_clicked',
  CHAT_WITH_SUPPORT: 'help_chat_with_support_tab_clicked',
  GO_TO_LEARNING_SITE: 'goto_learning_site_clicked',
  SWITCH_LEARNING_SITE: 'ls_switch_clicked',
  LOGOUT: 'logout',
  USER_SWITCHED_TO_OLD_UI: 'content_old_ui_view_switched',
  SWITCHED_TO_OLD_UI: 'content_old_ui_view_clicked',
  LEARNERS: 'users_tab_clicked',
  ANALYTICS: 'analytics_tab_clicked',
  REVIEWS: 'reviewers_tab_clicked',
  DASHBOARD: 'content_tab_clicked',
  PRIVACY_POLICY: 'privacy_policy_clicked',
  ASSET: 'asset_tab_clicked',
  CONTENT_CENTER: 'content_center_tab_clicked',
  SYSTEM_LOGS: 'system_logs_section_clicked',
  EDIT_READINESS_DASHBOARD: 'edit_readiness_dashboard_tab_clicked',
  MANAGE_HOMEPAGES: 'manage_homepage_tab_clicked',
  MANAGE_PAGES: 'manage_pages_tab_clicked',
  DIGITAL_SALES_ROOMS: 'manage_digital_sales_rooms_clicked',
  CALLAI_ADMIN: 'callai_tab_clicked',
  SETTINGS_ICON: 'settings_icon_clicked',
  HELP_AND_SUPPORT: 'help_and_support_button_clicked',
  VIEW_PROFILE: 'view_profile_clicked',
};
